import React, {Component} from 'react';
// Composants
import KeyboardArrowDownIcon from 'react-material-icons/icons/hardware/keyboard-arrow-down';
import AutoComplete from 'material-ui/AutoComplete';
// Style
import './autoCompleteInput.css';

class AutoCompleteInput extends Component {

    constructor (props) {
        super(props);
        this.state = {
            errorText: null,
            searchText: props.itemDisplayed ? props.itemDisplayed.name : '',
            itemDisplayed: props.itemDisplayed
        };
    }

    //Permet d'afficher l'item sélectionné dans le champ 'search text' lorsque que 'props.itemDisplayed' change
    componentWillReceiveProps (nextProps) {
        if (nextProps.itemDisplayed !== this.state.itemDisplayed && nextProps.itemDisplayed !== '') {
            this.setState({
                itemDisplayed: nextProps.itemDisplayed,
                searchText: nextProps.itemDisplayed ? nextProps.itemDisplayed.name : '',
            })
        } else {
            this.setState({
                itemDisplayed: nextProps.itemDisplayed,
            });
        }
    }

    clearInputText = () => this.setState({searchText: ''});

    /**
     * Fonction qui réalise le filtrage lorsque l'utilisateur
     * rentre du text dans l'input
     */
    filter = (searchText, key) => key.toLowerCase().includes(searchText.toLowerCase());

    /**
     * Fonction qui ouvre le dropdown des solutions
     * Note: Elle ne ferme pas le dropdown (c'est un bug du à material
     * il n'est pas possible de savoir l'état du focus lors de l'entrée dans la fonction
     */
    toggleAutoCompletePropositionDropDown = () => {
        this.clearInputText();
        this.inputRef.refs.searchTextField.focus();
    };

    displayPreviousSearch = () => {
        this.setState((state, props) => ({
            searchText: props.itemDisplayed ? props.itemDisplayed.name : ''
        }));
    };

    dataSourceConfig = {
        text: 'name',
        value: 'id',
    };

    /**
     * Fonction appelé lorsque l'utilisateur choisi un item dans la liste
     * de l'input
     * @param chosenRequest
     * @param index
     */
    handleNewRequest = (chosenRequest) => {
        this.setState({
            errorText: null
        });
        this.props.selectItem(chosenRequest);
    };

    /**
     * Lorsque l'input change on reset les erreurs eventuelles
     */
    handleUpdateInput = (searchText) => this.setState({errorText: null, searchText: searchText});

    render () {
        return (
            <div className="autoCompleteInput">
                <AutoComplete
                    ref={input => {this.inputRef = input;}}
                    name={this.props.name}
                    dataSource={this.props.dataSource}
                    dataSourceConfig={this.dataSourceConfig}
                    searchText={this.state.searchText}
                    hintText={this.props.hintText}
                    filter={this.filter}
                    onNewRequest={this.handleNewRequest}
                    onUpdateInput={this.props.onUpdateInput ? this.props.onUpdateInput : this.handleUpdateInput}
                    openOnFocus={true}
                    onFocus={this.clearInputText}
                    onClose={this.displayPreviousSearch}
                    disabled={this.props.disabled}
                    errorText={this.state.errorText}
                    menuCloseDelay={0}
                    {...this.props.configs.input}
                    listStyle={{ maxHeight: '50vh', overflow: 'auto' }}
                />
                <KeyboardArrowDownIcon onClick={this.toggleAutoCompletePropositionDropDown}
                                       {...this.props.configs.icon}/>
            </div>
        );
    }

}

AutoCompleteInput.defaultProps = {
    dataSource: [],
    configs: {},
    disabled: false,
    itemDisplayed: ''
};

export default AutoCompleteInput;



// WEBPACK FOOTER //
// ./src/components/autoCompleteInput/AutoCompleteInput.js